export default {
      id: "i-shield-usage",
      viewBox: "0 0 83 83",
      url: __webpack_public_path__ + "img/sprite.svg#i-shield",
      toString: function () {
        return this.url;
      }
    }